export type PriorityCode = string;
export type PriorityVariant =
  | "primary"
  | "secondary"
  | "success"
  | "danger"
  | "warning"
  | "info"
  | "light"
  | "dark";

export interface PriorityConfig {
  variant: PriorityVariant;
  label: string;
  order: number;
}

const PRIORITY_CONFIG: Record<string, PriorityConfig> = {
  stat: { variant: "danger", label: "STAT", order: 1 },
  urgent: { variant: "warning", label: "Urgent", order: 2 },
  routine: { variant: "info", label: "Routine", order: 3 },
};

const DEFAULT_PRIORITY_CONFIG: PriorityConfig = {
  variant: "secondary",
  label: "Routine",
  order: 99,
};

export function normalizePriorityCode(priority?: string | null): PriorityCode {
  const normalized = priority?.toLowerCase().trim();
  if (!normalized) return "routine";
  return normalized;
}

function formatPriorityLabel(code: string): string {
  if (!code) return DEFAULT_PRIORITY_CONFIG.label;
  return code
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

export function getPriorityConfig(priority?: string | null): PriorityConfig {
  const code = normalizePriorityCode(priority);
  const preset = PRIORITY_CONFIG[code];
  if (preset) return preset;

  return {
    variant: DEFAULT_PRIORITY_CONFIG.variant,
    label: formatPriorityLabel(code),
    order: DEFAULT_PRIORITY_CONFIG.order,
  };
}
